import { RootState } from '../../../state/store';
import { Fault } from '../model/Fault';
import { FaultState } from '../model/FaultState';

const getFaultState = (state: RootState): FaultState => state.fault;

export const getFaultSelector = (state: RootState): Fault['error'] | undefined => getFaultState(state)?.error;

export const isFaultHandledSelector = (state: RootState): boolean => !!getFaultState(state)?.isHandled;
